import type { InputParams, ITpaasEvent } from '@schibsted/pulse-sdk';
import type { PulseContextProviderConfig } from '../../types/index.js';

export const buildProviderInput = (
  pulseConfig: PulseContextProviderConfig,
): InputParams<ITpaasEvent>['provider'] => ({
  stage: pulseConfig.stage,
  product: pulseConfig.product,
});
